export default "__VITE_ASSET__524b3b46__"